/**
 * Извлекает текст ошибки из ответа сервера
 * @param {Error} error - объект ошибки
 * @param {string} defaultMessage - сообщение по умолчанию
 * @returns {string} - текст ошибки
 */
export const getErrorMessage = (error, defaultMessage = "Произошла ошибка") => {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.error?.code ||
    error?.response?.data?.message ||
    error?.message ||
    defaultMessage
  );
};
